import React from "react";
import { Grid, IconButton, Paper, Typography } from "@material-ui/core";
import CreateIcon from "@material-ui/icons/Create";
import makeStyles from "@material-ui/core/styles/makeStyles";
import InfoBox from "../components/PrmDetails/InfoBox";
import { useHistory } from "react-router-dom";
import paths from "../routes/paths";

export default function PrmDetails(props) {
  const classes = styles();
  const { passenger } = props.location.state;
  const history = useHistory();

  return (
    <Paper square elevation={0} className={classes.container}>
      <Grid
        container
        direction={"row"}
        justify={"space-between"}
        alignItems="flex-end"
        className={classes.nameContainer}
      >
        <Typography className={classes.passengerName}>
          {passenger.name} {passenger.surname}
        </Typography>
        <IconButton
          onClick={() =>
            history.push({ pathname: paths.PRM_UPDATE, state: { passenger } })
          }
          className={classes.updateButton}
        >
          <CreateIcon className={classes.icon} />
        </IconButton>
      </Grid>
      <Grid
        container
        direction={"column"}
        justify="center"
        alignItems="flex-start"
      >
        <Grid
          container
          direction={"row"}
          justify={"space-between"}
          alignItems="flex-start"
        >
          <InfoBox title={"PRM"} value={passenger.type} main />
          <InfoBox title={"Station"} value={"55"} main hasBorder />
          <InfoBox title={"Posizione"} value={"Yamamay"} main />
        </Grid>
        <div className={classes.divisor} />
        <Grid
          container
          direction={"row"}
          justify={"space-between"}
          alignItems="flex-start"
        >
          <InfoBox title={"Volo"} value={"MUC/NAP"} />
          <InfoBox title={"Codice"} value={passenger.ticketCode} />
          <InfoBox title={"Gate"} value={passenger.gate} />
        </Grid>
        <div className={classes.divisor} />
        <Grid
          container
          direction={"row"}
          justify={"space-between"}
          alignItems="flex-start"
        >
          <InfoBox title={"STD"} value={"06:00"} />
          <InfoBox title={"ETD"} value={"06:10"} />
          <InfoBox title={"Block-Off"} value={"06:10"} />
        </Grid>
        <div className={classes.divisor} />
        <Grid
          container
          direction={"row"}
          justify={"space-between"}
          alignItems="flex-start"
        >
          <InfoBox title={"Riservato"} value={"Y"} />
          <InfoBox title={"P.to Chiamata"} value={"CK"} />
          <InfoBox title={"Orario"} value={"05:19"} />
        </Grid>
        <div className={classes.divisor} />
        <Grid
          container
          direction={"row"}
          justify={"space-between"}
          alignItems="flex-start"
        >
          <InfoBox title={"Addetti IN"} value={"Simeoli, D'Acunto, Perna"} />
          <InfoBox
            title={"Addetti OUT"}
            value={"Gallo, Benedetti, Pratt"}
            hasBorder
          />
          <InfoBox title={"Note"} value={"Da WCHC a WCHS"} />
        </Grid>
      </Grid>
    </Paper>
  );
}

const styles = makeStyles(theme => ({
  container: {
    padding: 16
  },
  nameContainer: {
    marginBottom: 16
  },
  passengerName: {
    fontSize: 24,
    fontWeight: "500"
  },
  updateButton: {
    backgroundColor: theme.palette.primary.main
  },
  icon: {
    color: theme.palette.white
  },
  divisor: {
    height: 1,
    width: "100%",
    backgroundColor: theme.palette.grey.main,
    marginTop: 8,
    marginBottom: 8
  }
}));
